import { FC } from 'react';
import { EntityChip } from '@silverfort/sf-components';

interface Props {
    groups: string[];
}

const Groups: FC<Props> = ({ groups }) => (
    <div className="px-4 flex flex-col gap-4">
        <span className="font-sf text-13 leading-[15.51px] text-sf-gray-500">Group membership ({groups.length})</span>
        {/* todo: search for more stable key for EntityChip */}
        <div className="flex gap-2 flex-wrap">
            {groups.map((group, index) => (
                <EntityChip key={`${group}_${index}`} type="background" text={group} />
            ))}
        </div>
    </div>
);

export default Groups;
